export default __webpack_public_path__ + "static/media/logo.59dff8e2.svg";